import React from 'react';
import useServicesPerYearPercentageChart from './hooks/useServicesPerYearPercentageChart';
import ChartContainer from '../../../Common/Services/charts/apex-charts/ChartContainer';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const ServicesPerYearPercentage = ({ heigth = 400 }) => {
    const { module } = useServicesChartsDataContext();
    const { chartConfig } = useServicesPerYearPercentageChart();

    return (
        <ChartContainer
            title={`Evolução ${module.sectionTitle} por Ano (%)`}
            options={chartConfig.options}
            series={chartConfig.series}
            height={heigth}
        />
    );
};
